import { cn } from '@/lib/utils';

/**
 * @file Overlay.jsx
 * @description Add an overlay on the children
 * @version 0.0.1
 * Created at: 11/08/2025
 * Updated at: 11/08/2025
 */
export const Overlay = ({ children, className }) => {
  return (
    <div className={cn('relative bg-gradient-to-b from-primary/25 to-foreground/50', className)}>
      {children}
    </div>
  );
};
